module.exports = __webpack_public_path__ + "js/0.838aa4ff.worker.js"